import { useCallback } from "react";
import { parseExcelFile } from "../excelParser";

export const useExcelParser = ({
  filters,
  handleApplyFilters,
  setIsLoading,
  t,
  toast,
}) => {
  const handleExcelUpload = useCallback(
    async (file) => {
      if (!file) return;

      if (!file.name.match(/\.(xlsx|xls|csv)$/i)) {
        toast({
          title: t("reports.invalidFile", "ملف غير صالح"),
          description: t("reports.uploadExcelOnly", "يرجى رفع ملف Excel فقط (.xlsx, .xls, .csv)"),
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      try {
        setIsLoading(true);
        toast({
          title: t("reports.uploadingFile", "جاري رفع الملف..."),
          description: file.name,
          status: "info",
          duration: 2000,
          isClosable: true,
        });

        const parsedData = await parseExcelFile(file);
        handleApplyFilters({
          uploadedFile: file,
          uploadedFileName: file.name,
          uploadedData: parsedData,
        });

        toast({
          title: t("reports.fileUploaded", "تم رفع الملف"),
          description: `${t("reports.parsedItems", "تم تحليل")} ${parsedData.length} ${t("reports.rows", "صف")}`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } catch (error) {
        toast({
          title: t("reports.uploadError", "خطأ في رفع الملف"),
          description: error.message,
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [handleApplyFilters, setIsLoading, t, toast]
  );

  const removeExcelFile = useCallback(() => {
    handleApplyFilters({
      uploadedFile: null,
      uploadedFileName: "",
      uploadedData: null,
    });
  }, [handleApplyFilters]);

  return {
    excelData: filters.uploadedData,
    excelFileName: filters.uploadedFileName,
    handleExcelUpload,
    removeExcelFile,
  };
};
